"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlUnlogged = exports.storageSet = exports.storageRemoveAll = exports.storageRemove = exports.storageGet = exports.scrollSmooth = exports.removeUserDealerLocalData = exports.reducerCreate = exports.permission = exports.paramURL = exports.listboxItemAnimation = exports.jwtParse = exports.jwtGet = exports.isUserGroup = exports.indexedDBClear = exports.i18n = exports.getUserGroup = exports.formatPhone = exports.formatMoney = exports.formatDateDayMonth = exports.formatDate = exports.formatCPF = exports.formatCNPJ = exports.formatCEP = exports.default = exports.customAttributes = exports.copyToClipboard = exports.cookieSet = exports.cookieRemoveAll = exports.cookieRemove = exports.cookieGet = exports.accordionAnimate = exports.WINDOW = exports.Ajax = void 0;
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));
var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-float"));
var _immutee = _interopRequireDefault(require("immutee"));
var _axios = _interopRequireDefault(require("axios"));
var _lang = _interopRequireDefault(require("webmotors-react-pj/i18n/lang"));
var _config = require("webmotors-react-pj/config");
const WINDOW = exports.WINDOW = typeof window !== 'undefined' && window;
const urlUnlogged = exports.urlUnlogged = ['/', '/logout', '/redefinir-senha', '/redefinir-senha/email-enviado', '/redefinir-senha/resetar-senha', '/redefinir-senha/troca-de-seguranca', '/usuario/atualizar', '/usuario/senha-atualizada', '/usuario/introducao-cockpit', '/password/introduction-reset', '/password/introduction-update', '/password/reset', '/password/update', '/password/updated', '/password/dealer', '/terms/policy-privacy', '/tips'];
const reducerCreate = (state, action, name) => {
  const success = "".concat(name);
  const failure = "".concat(name, "_FAILURE");
  const immutable = (0, _immutee.default)(state);
  switch (action.type) {
    case success:
      {
        return immutable.set('result', action.payload).set('fetched', true).done();
      }
    case failure:
      {
        return immutable.set('result', []).set('fetched', true).set('error', action.payload).done();
      }
    default:
      {
        return state;
      }
  }
};
exports.reducerCreate = reducerCreate;
const scrollSmooth = function (to) {
  let duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  if (WINDOW) {
    clearTimeout(window.scrollSmoothTimerCache);
    if (duration <= 0) {
      return;
    }
    const difference = to - window.scrollY - 100;
    const perTick = difference / duration * 10;
    window.scrollSmoothTimerCache = setTimeout(() => {
      if (!Number.isNaN((0, _parseInt2.default)(perTick, 10))) {
        window.scrollTo(0, window.scrollY + perTick);
        scrollSmooth(to, duration - 10);
      }
    }, 10);
  }
};
exports.scrollSmooth = scrollSmooth;
const accordionAnimate = (testOpen, item) => {
  const tag = item;
  const getPadding = padding => (0, _parseFloat2.default)(getComputedStyle(tag)[padding]);
  tag.classList.add('accordion--transition');
  if (testOpen) {
    tag.style.height = 'auto';
    const {
      clientHeight
    } = tag;
    const height = clientHeight + getPadding('paddingTop') + getPadding('paddingBottom');
    tag.style.height = '0px';
    tag.style.height = "".concat(height, "px");
  } else {
    tag.style.height = '0px';
    tag.addEventListener('transitionEnd', () => tag.classList.remove('accordion--transition'));
  }
};
exports.accordionAnimate = accordionAnimate;
const paramURL = e => {
  const query = new RegExp("".concat(e, "=.+&|").concat(e, "=.+$"), 'g');
  const replaceQuery = new RegExp("&|^".concat(e, "="), 'g');
  const params = query.exec(window.location.search);
  if (params && params[0]) {
    return params[0].replace(replaceQuery, '');
  }
  return false;
};
exports.paramURL = paramURL;
const cookieSet = (key, value) => {
  const hostname = window.location.hostname.replace(/^\w+/, '');
  window.document.cookie = "".concat(key, "=").concat(value, ";domain=").concat(hostname, ";path=/;Secure");
};
exports.cookieSet = cookieSet;
const cookieGet = key => {
  let cookie;
  const value = "; ".concat(window.document.cookie);
  const parts = value.split("; ".concat(key, "="));
  if (parts.length === 2) {
    cookie = parts.pop().split(';').shift();
  }
  return cookie;
};
exports.cookieGet = cookieGet;
const cookieRemove = key => {
  const hostname = window.location.hostname.replace(/^\w+/, '');
  if (key) {
    window.document.cookie = "".concat(key, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=").concat(hostname, ";path=/");
  }
};
exports.cookieRemove = cookieRemove;
const cookieRemoveAll = function () {
  let exceptArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (exceptArray.constructor.name === 'Array') {
    const cookies = document.cookie.split('; ');
    cookies.forEach(item => {
      const d = window.location.hostname.split('.');
      while (d.length > 0) {
        var _window, _window$location;
        const name = item.split(';')[0].split('=')[0];
        const hasException = exceptArray.filter(exceptName => exceptName === name);
        const cookieBase = "".concat(window.encodeURIComponent(name), "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=").concat(d.join('.'), " ;path=");
        const p = (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname.split('/');
        if (!hasException.length) {
          document.cookie = "".concat(cookieBase, "/");
        }
        while (p.length > 0) {
          if (!hasException.length) {
            document.cookie = cookieBase + p.join('/');
          }
          p.pop();
        }
        d.shift();
      }
    });
  }
};
exports.cookieRemoveAll = cookieRemoveAll;
const indexedDBClear = dbName => {
  window.indexedDB.deleteDatabase(dbName);
};
exports.indexedDBClear = indexedDBClear;
const storageSet = function () {
  let key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return window.localStorage.setItem(key, value);
};
exports.storageSet = storageSet;
const storageGet = function () {
  let key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return window.localStorage.getItem(key);
};
exports.storageGet = storageGet;
const storageRemove = function () {
  let key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return window.localStorage.removeItem(key);
};
exports.storageRemove = storageRemove;
const storageRemoveAll = function () {
  let exceptStorage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (exceptStorage.constructor.name === 'Array') {
    const {
      localStorage: itemsToRemove
    } = window;
    Object.keys(itemsToRemove).forEach(key => {
      const exceptItem = exceptStorage.filter(item => item === key);
      if (!exceptItem.length) {
        itemsToRemove.removeItem(key);
      }
    });
  }
};
exports.storageRemoveAll = storageRemoveAll;
const jwtParse = jwt => {
  if (jwt && jwt.indexOf('.') !== -1) {
    return JSON.parse(window.decodeURIComponent(Array.prototype.map.call(atob(jwt.split('.')[1].replace('-', '+').replace('_', '/')), c => "%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2))).join('')));
  }
  return {
    cnpj: '',
    sid: '',
    unique_name: '',
    nameid: '',
    email: '',
    status: '',
    idGrupo: '',
    idUserHub: '',
    nomeGrupo: '',
    utilizaCrmTerceiro: '',
    statusPolicy: '',
    isUserHub: '',
    nomeFantasia: '',
    tenant: '',
    role: '',
    permissions: [],
    produtos: []
  };
};
exports.jwtParse = jwtParse;
const jwtGet = function () {
  let cookieName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (cookieName) {
    const jwtNamed = cookieGet(cookieName);
    return jwtParse(jwtNamed);
  }
  const jwt = cookieGet('CockpitLogged') || cookieGet('AppLogged');
  return jwtParse(jwt);
};
exports.jwtGet = jwtGet;
const AjaxAction = function (param) {
  var _window2, _window2$location;
  let urlToRedirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let cookieName = arguments.length > 2 ? arguments[2] : undefined;
  const unloggedPage = [...urlUnlogged];
  const unloggedPageExcept = ['/', '/logout'];
  const urlUnauthenticated = unloggedPage.filter(item => !unloggedPageExcept.includes(item)).includes((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.pathname);
  const urlRedirect = urlToRedirect ? urlToRedirect : "".concat(_config.UrlCockpit, "/logout?expired=true");
  if (param.status === 401 && (Boolean(cookieGet('CockpitLogged')) && !urlUnauthenticated || cookieName !== 'CockpitLogged' && Boolean(cookieGet(cookieName)))) {
    window.location.href = urlRedirect;
  }
};
const AjaxRefresh = (AjaxFn, props, jwt) => {
  AjaxFn({
    url: "".concat(_config.ApiLogin, "/access/sso/refreshtoken"),
    method: 'POST',
    data: {
      Token: jwt
    },
    refresh: true
  }).then(e => {
    if (e.success) {
      cookieSet('CockpitLogged', e.data.jwt);
      AjaxFn(props);
    } else {
      AjaxAction(e);
    }
  });
};
const Ajax = props => {
  const {
    cookieName = 'CockpitLogged',
    urlToRedirect = false
  } = props;
  const json = jwtGet(cookieName);
  const getStatus = param => param.response ? param.response.status : param.status || 0;
  const getPromise = param => Promise.resolve({
    data: param.data,
    status: param.status,
    success: param.success,
    target: param.target,
    response: param.response
  });
  const msgText = {
    0: _lang.default.utils.status0,
    400: _lang.default.utils.status400,
    401: _lang.default.utils.status401,
    403: _lang.default.utils.status403,
    404: _lang.default.utils.status404,
    405: _lang.default.utils.status405,
    407: _lang.default.utils.status407,
    408: _lang.default.utils.status408,
    409: _lang.default.utils.status409,
    411: _lang.default.utils.status411,
    412: _lang.default.utils.status412,
    413: _lang.default.utils.status413,
    414: _lang.default.utils.status414,
    415: _lang.default.utils.status415,
    416: _lang.default.utils.status416,
    417: _lang.default.utils.status417,
    500: _lang.default.utils.status500,
    501: _lang.default.utils.status501,
    502: _lang.default.utils.status502,
    503: _lang.default.utils.status503,
    504: _lang.default.utils.status504,
    505: _lang.default.utils.status505,
    507: _lang.default.utils.status507,
    508: _lang.default.utils.status508
  };
  const getError = param => {
    const status = getStatus(param);
    const data = msgText[status];
    const {
      response
    } = param;
    const dataResponse = response || undefined;
    const responseHas = Boolean(response);
    console.error("[".concat(status, "] ").concat(data));
    AjaxAction(responseHas ? response : param, urlToRedirect, cookieName);
    return getPromise({
      data,
      status,
      target: props.target,
      success: false,
      response: dataResponse
    });
  };
  const getSuccess = param => {
    const data = (param.data.data === true ? param.data : param.data.data) || param.data.Result || param.data.result || param.data.Retorno || param.data;
    const r = getPromise({
      data,
      status: getStatus(param),
      target: props.target,
      success: true
    });
    return r;
  };
  const {
    exp: timeExpires
  } = json;
  const timeNow = Date.now();
  const timeExpiresToSecound = new Date(timeExpires * 1000).getTime();
  const jwt = cookieGet(cookieName);
  if (timeExpires && Boolean(timeExpiresToSecound) && timeNow > timeExpiresToSecound && !props.refresh && cookieName === 'CockpitLogged') {
    AjaxRefresh(Ajax, props, jwt);
  }
  const {
    url,
    method = 'POST',
    headers,
    data,
    withCredentials = false
  } = props;
  const request = _axios.default.request({
    url,
    method,
    data,
    withCredentials,
    headers: !headers ? {
      'Content-Type': 'application/json',
      Authorization: "Bearer ".concat(jwt)
    } : headers,
    params: method === 'GET' || method === 'HEAD' ? data : ''
  }).then(e => e.status >= 200 && e.status < 300 ? getSuccess(e) : getError(e)).catch(e => {
    const response = e.response || {};
    const {
      status,
      data: body
    } = response;
    const error = body && (body.errors || body.Messages && body.Messages[0] || body.data);
    AjaxAction(response);
    if (status >= 500) {
      return getError(e);
    }
    if (error) {
      return getPromise({
        data: error,
        status,
        success: false,
        target: props.target,
        response: body
      });
    }
    return getError(e);
  });
  return request;
};
exports.Ajax = Ajax;
const listboxItemAnimation = () => {
  setTimeout(() => [...document.querySelectorAll('.listbox__item')].forEach((item, i) => setTimeout(() => item.classList.add('listbox__item--active'), Math.min(i * 60, 2000))), 10);
};
exports.listboxItemAnimation = listboxItemAnimation;
const formatDate = dateString => new Date(dateString).toLocaleDateString('pt-BR', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
});
exports.formatDate = formatDate;
const formatMoney = number => Number(number).toLocaleString('pt-br', {
  style: 'currency',
  currency: 'BRL'
});
exports.formatMoney = formatMoney;
const formatPhone = number => number.replace(/\D/g, '').replace(/(\d{2})((?=\d{9})(\d{5})(\d{4})|(?=\d{8})(\d{4})(\d{4}))/, function () {
  if (arguments.length <= 3 ? undefined : arguments[3]) {
    return "(".concat(arguments.length <= 1 ? undefined : arguments[1], ") ").concat(arguments.length <= 3 ? undefined : arguments[3], "-").concat(arguments.length <= 4 ? undefined : arguments[4]);
  }
  if (arguments.length <= 5 ? undefined : arguments[5]) {
    return "(".concat(arguments.length <= 1 ? undefined : arguments[1], ") ").concat(arguments.length <= 5 ? undefined : arguments[5], "-").concat(arguments.length <= 6 ? undefined : arguments[6]);
  }
  console.error("formatPhone: invalid for \"".concat(number, "\""));
  return '';
});
exports.formatPhone = formatPhone;
const formatCEP = number => number.replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2');
exports.formatCEP = formatCEP;
const formatCNPJ = number => number.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
exports.formatCNPJ = formatCNPJ;
const formatCPF = number => number.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
exports.formatCPF = formatCPF;
const formatDateDayMonth = dateString => new Date(dateString).toLocaleDateString('pt-BR', {
  month: '2-digit',
  day: '2-digit'
});
exports.formatDateDayMonth = formatDateDayMonth;
const isUserGroup = () => permission.has(permission.id.selectStore);
exports.isUserGroup = isUserGroup;
const i18n = () => {
  const langConfig = {
    default: {
      lang: '',
      alpha2Code: '',
      country: '',
      tenant: 0
    },
    76: {
      lang: 'pt',
      alpha2Code: 'BR',
      country: 'Brazil',
      tenant: 76
    },
    604: {
      lang: 'es',
      alpha2Code: 'PE',
      country: 'Peru',
      tenant: 604
    },
    170: {
      lang: 'es',
      alpha2Code: 'CO',
      country: 'Colombia',
      tenant: 170
    },
    32: {
      lang: 'es',
      alpha2Code: 'AR',
      country: 'Argentina',
      tenant: 32
    }
  };
  const {
    tenant
  } = jwtGet();
  return langConfig[tenant] || langConfig.default;
};
exports.i18n = i18n;
const permission = exports.permission = {
  has: id => {
    const {
      permissions: permissionJWT
    } = jwtGet();
    if (id.constructor.name === 'Number') {
      const permissionValid = permissionJWT.includes(id.toString());
      return permissionValid;
    }
    console.error('permission.has(<number>): the parameter is not a number');
    return false;
  },
  id: {
    invoiceView: 43,
    extractLeadView: 43,
    planControlEdit: 43,
    userListView: 18,
    userEdit: 19,
    userProfileEdit: 39,
    userWorkingHoursEdit: 40,
    userLeadDistributionEdit: 41,
    userInactivate: 21,
    userPasswordReset: 84,
    userAdd: 22,
    dealerEdit: 23,
    termView: 51,
    termAccept: 52,
    termViewProduct: 51,
    termAcceptProduct: 52,
    storeView: 43,
    storeHire: 44,
    selectStore: 92,
    accessCockpit: 91,
    leadsListMadeAccess: 9,
    leadsView: 1,
    leadsAcceptOrDecline: 5,
    leadsAccessDeclined: 7,
    leadsAccessSold: 6,
    leadsAccessLost: 8,
    leadsManage: 4,
    kanbanAccess: 2,
    kanbanAllSellers: 10,
    messagesReady: 38,
    inventoryWriteOff: 13,
    scoresAndBenefitsView: 31,
    benefitsRedeem: 42,
    inventoryConsult: 29,
    vehicleListView: '',
    vehiclesSort: '',
    vehiclePublishOrUnpublish: '',
    vehicleButtonDelete: '',
    vehicleButtonAdd: '',
    vehicleInclude: 30,
    vehicleEvaluate: 37,
    vehicleSell: '',
    channelsIntegratedViewing: '',
    channelsSales: 48,
    exchangeModalityAd: '',
    draftEdit: '',
    vehicleAddCo: 73,
    PlateManualInclusionCo: 57,
    vehicleButtonAddCo: 71,
    vehicleButtonDeleteCo: 70,
    inventoryConsultCo: 64,
    draftEditCo: 74,
    vehicleIncludeCo: 78,
    exchangeModalityAdCo: 68,
    vehiclesSortCo: 66,
    vehiclePublishOrUnpublishCo: 69,
    vehicleListViewCo: 77,
    channelsIntegratedViewingCo: 76,
    universityAccess: 33,
    gearboxAccess: 32,
    autoguruAccess: 34
  }
};
if (WINDOW) {
  (ElementProto => {
    const item = ElementProto;
    if (typeof ElementProto.matches !== 'function') {
      item.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
        const element = this;
        const elements = (element.document || element.ownerDocument).querySelectorAll(selector);
        let index = 0;
        while (elements[index] && elements[index] !== element) {
          ++index;
        }
        return Boolean(elements[index]);
      };
    }
    if (typeof ElementProto.closest !== 'function') {
      item.closest = function closest(selector) {
        let element = this;
        while (element && element.nodeType === 1) {
          if (element.matches(selector)) {
            return element;
          }
          element = element.parentNode;
        }
        return null;
      };
    }
  })(window.Element.prototype);
}
const customAttributes = (props, except) => {
  const propsCustom = {};
  Object.entries(props).forEach(item => {
    const [propKey, propValue] = item;
    const regex = new RegExp("^(?!(".concat(except, ")).+"));
    if (regex.test(propKey)) {
      propsCustom[propKey] = propValue;
    }
  });
  return propsCustom;
};
exports.customAttributes = customAttributes;
const copyToClipboard = textToCopy => {
  const dummy = document.createElement('input');
  document.body.appendChild(dummy);
  dummy.setAttribute('value', textToCopy);
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);
};
exports.copyToClipboard = copyToClipboard;
const removeUserDealerLocalData = () => {
  storageRemoveAll();
  cookieRemoveAll(['CockpitNotifications']);
};
exports.removeUserDealerLocalData = removeUserDealerLocalData;
const getUserGroup = _ref => {
  let {
    id,
    name,
    redirect
  } = _ref;
  Ajax({
    url: "".concat(_config.ApiLogin, "/access/sso/login/group/dealer"),
    data: {
      idCliente: id
    },
    method: 'GET'
  }).then(f => {
    const {
      data,
      success
    } = f;
    if (success) {
      const reload = () => window.location.reload();
      removeUserDealerLocalData();
      cookieSet('CockpitLogged', data.jwt);
      if (name) {
        cookieSet('CockpitStoreName', name);
      }
      setTimeout(() => {
        if (redirect) {
          if (redirect !== window.location.href) {
            window.location.href = "".concat(redirect);
          } else {
            reload();
          }
        } else {
          reload();
        }
      }, 100);
    } else {
      console.error(f);
    }
  });
};
exports.getUserGroup = getUserGroup;
var _default = exports.default = WINDOW;